export default function useAnalytics() {
  const api = useApi()
  const app = useNuxtApp()

  const createEvent = async (params: {
    name: string
    options?: { distinctId?: string | undefined }
    properties?: { [key: string]: any }
  }) => {
    try {
      if (import.meta.client && !localStorage.getItem('adminOpaqueToken')) {
        await api.events.create({
          name: params.name,
          properties: params.properties,
          ...params.options,
        })
      }
    }
    catch (error) {
      console.error(error)
    }
  }

  return {
    createEvent,
    posthog: app.$posthog,
  }
}
